var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 54,
    viewBox: "0 0 52 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_5258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2906 46.3848C47.2046 48.7146 43.1186 51.0445 39.0325 53.3744C37.0793 54.4881 34.3292 51.6158 36.492 50.3826C38.7033 49.1217 40.9146 47.8608 43.1259 46.5999C37.9384 46.5999 32.7507 46.5999 27.5632 46.5999C20.5193 46.5999 13.558 47.1489 7.59124 42.5838C0.706655 37.3166 0 29.8613 0 21.9369C0 15.6197 0 9.30244 0 2.98523C0 1.07904 3.6226 -0.549237 3.6226 1.76199C3.6226 7.61438 3.6226 13.4667 3.6226 19.3191C3.6226 26.7039 3.43338 33.9607 9.75854 39.205C15.4681 43.9387 22.8081 43.0681 29.7052 43.0681C34.3168 43.0681 38.9283 43.0681 43.5399 43.0681C41.2831 41.7129 39.0263 40.3576 36.7695 39.0023C34.5201 37.6514 36.9846 34.9894 39.0783 36.2468C43.1104 38.6682 47.1426 41.0896 51.1747 43.5111C52.1421 44.0921 52.3562 45.7772 51.2906 46.3848Z",
    fill: "#6EADFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_5258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7c693f082d3a605bc4bcc22b583eddca.svg";
export { ForwardRef as ReactComponent };